<template>
  <div class="signature d-flex justify-content-end">
    <div
      v-if="data"
      class="d-flex align-items-center justify-content-end full-height half-width"
    >
      <div class="d-flex flex-column" text-right>
        <span>
          {{ approvalText }}
          {{ data.kind === "overridden" ? " Manually" : "" }}
        </span>
        <span>{{ signatureDate }}</span>
      </div>
      <img
        v-if="data.kind !== 'overridden'"
        :src="data.image_url"
        alt="Signature"
      />
    </div>
  </div>
</template>

<script lang="ts">
import date from "serviceshift-ui/shared/src/filters/date";

import { Signature } from "@/typings/signature";

export default {
  props: {
    data: {
      type: Object as () => Signature,
      default: null
    },
    type: {
      type: String,
      default: ""
    },
    approvalText: {
      type: String,
      default: "Approved"
    }
  },
  computed: {
    signatureDate() {
      return date(this.data.signature_time);
    }
  }
};
</script>

<style lang="scss" scoped>
.signature {
  padding: 5px 0;
  img {
    height: 90px;
  }
}
.full-height {
  height: 100%;
}
.half-width {
  width: 50%;
}
</style>
